import { FormLayout, Modal, TextField, Form, Checkbox } from '@shopify/polaris';
import { useEffect, useState } from 'react';

import helpers from 'helpers';

import { lengthLessThan, notEmpty, useField, useForm } from '@shopify/react-form';

import __ from 'languages/index';
import { TypedVehicle, useMutateCreateVehicle, useMutateGetVehicle, useUpdateVehicle } from 'queries/vehicle.query';

/**
 *   Create upload Modal for Notification
 */

// eslint-disable-next-line import/no-anonymous-default-export

export default function VehicleModal({ onClose, show, currentVehicleID }: { onClose: Function; show: boolean; currentVehicleID?: bigint }) {
  const { mutateAsync: createEntity, isPending: creating, isSuccess: creatingSuccess } = useMutateCreateVehicle();
  const { mutateAsync: updateEntity, isPending: updating, isSuccess: updateSuccess } = useUpdateVehicle();
  const { mutateAsync: getVehicle, data: vehicleData } = useMutateGetVehicle();

  const [entity, setEntity] = useState<TypedVehicle>(null);
  useEffect(() => {
    if (vehicleData) setEntity(vehicleData);
  }, [vehicleData]);

  useEffect(() => {
    if (currentVehicleID) {
      getVehicle(currentVehicleID);
    } else {
      setEntity(null);
    }
  }, [currentVehicleID, show]);

  const useFields = {
    name: useField<string>({
      value: entity?.name ?? '',
      validates: [
        notEmpty('Không được để trống trường này.'),
        lengthLessThan(250, 'No more than 250 characters.'),
        (inputValue) => {
          if (inputValue.length < 2) {
            return 'Your field is too short!';
          }
        },
      ],
    }),

    note: useField<string>({
      value: entity?.note ?? '',
      validates: [
        lengthLessThan(250, 'No more than 250 characters.'),
        (inputValue) => {
          if (inputValue.length < 2) {
            return 'Your field is too short!';
          }
        },
      ],
    }),

    license_plate: useField<string>({
      value: entity?.license_plate ?? '',
      validates: [
        notEmpty('Không được để trống trường này.'),
        (inputValue) => {
          if (inputValue && helpers.isUTF8(inputValue)) return 'Không được sử dụng mã UTF8 ở trường này.';
        },
      ],
    }),

    vehicle_status: useField<number>({
      value: entity?.vehicle_status,
      validates: [
        (inputVal) => {
          if (inputVal && !helpers.isNumber(inputVal)) return 'Phải là một số hợp lệ.';
        },
      ],
    }),
  };

  const {
    fields,
    submit,
    dirty,
    reset: resetForm,
  } = useForm({
    fields: useFields,

    async onSubmit(values) {
      try {
        // create new
        if (!currentVehicleID) {
          await createEntity({
            name: values.name,
            note: values.note,
            license_plate: values.license_plate,
            vehicle_status: values.vehicle_status,
          });
        } else {
          await updateEntity({
            id: String(currentVehicleID),
            name: values.name,
            note: values.note,
            license_plate: values.license_plate,
            vehicle_status: values.vehicle_status,
          });
        }
      } catch (e: any) {
        if (e.params !== undefined) {
          if (e.params.field !== undefined) {
            useFields[e.params.field].setError(__('check_this_field_again'));
          }
        }
      }
      return { status: 'success' };
    },
  });
  /* End form */

  useEffect(() => {
    if (updateSuccess || creatingSuccess) {
      resetForm();
      onClose();
    }
  }, [updateSuccess, creatingSuccess]);

  useEffect(() => {
    if (!currentVehicleID) {
      resetForm();
      setEntity(null);
    }
  }, [currentVehicleID]);

  const Actual_page = (
    <Modal
      open={show}
      onClose={() => onClose()}
      title={currentVehicleID ? 'Cập nhật phương tiện' : 'Tạo phương tiện'}
      primaryAction={{
        content: currentVehicleID ? 'Cập nhật' : 'Tạo',
        disabled: !dirty,
        loading: updating || creating,
        onAction: submit,
      }}
      secondaryActions={[
        {
          content: 'Close',
          onAction: () => onClose(),
        },
      ]}
    >
      <Modal.Section>
        <Form onSubmit={submit}>
          <FormLayout>
            <TextField autoFocus autoComplete="off" requiredIndicator label="Tên xe, loại xe" {...fields.name} />
            <TextField label="Ghi chú" autoComplete="off" {...fields.note} multiline={4} />
            <TextField label="Biển số" autoComplete="off" {...fields.license_plate} />

            <Checkbox
              label="Cho phép hoạt động"
              checked={Boolean(fields.vehicle_status.value === 1)}
              onChange={(e) => fields.vehicle_status.onChange(Number(e))}
            />
          </FormLayout>
        </Form>
      </Modal.Section>
    </Modal>
  );

  return <>{Actual_page}</>;
}

